import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId, openChat, EASE } from "../lib/site";

const LINKS = [
  ["microblading", "Microblading"],
  ["unghie", "Ricostruzione"],
  ["lavori", "Lavori"],
  ["contatti", "Contatti"],
  ["dove", "Dove siamo"],
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <header data-testid="nav-header" className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${scrolled ? "bg-[var(--cream)]/80 shadow-[0_1px_0_rgba(169,129,58,.18)] backdrop-blur-xl" : ""}`}>
      <div className="mx-auto flex h-[88px] max-w-[1400px] md:h-[100px] items-center justify-between px-5 md:px-10">
        <Logo onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }} />
        <nav className="hidden items-center gap-9 lg:flex">
          {LINKS.map(([id, label]) => (
            <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)} className="group relative text-sm tracking-wide text-[var(--ink)]">
              {label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-right scale-x-0 bg-[var(--gold)] transition-transform duration-500 group-hover:origin-left group-hover:scale-x-100" />
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button data-testid="nav-book-button" onClick={openChat} className="hidden rounded-full bg-[var(--ink)] px-6 py-3 text-sm text-[var(--cream)] transition-colors duration-300 hover:bg-[var(--gold-deep)] sm:block">
            Prenota
          </button>
          <button data-testid="nav-mobile-toggle" aria-label="Menu" onClick={() => setOpen((v) => !v)} className="grid h-11 w-11 place-items-center rounded-full border border-[var(--ink)]/20 lg:hidden">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div data-testid="nav-mobile-menu" initial={{ opacity: 0, y: -12 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }} transition={{ duration: 0.4, ease: EASE }} className="mx-4 rounded-3xl border border-[var(--gold)]/25 bg-[var(--cream)]/95 p-6 backdrop-blur-xl lg:hidden">
            {LINKS.map(([id, label], i) => (
              <motion.button key={id} data-testid={`nav-mobile-link-${id}`} onClick={() => go(id)} initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 * i }} className="block w-full border-b border-[var(--ink)]/10 py-4 text-left font-display text-2xl last:border-0">
                {label}
              </motion.button>
            ))}
            <button data-testid="nav-mobile-book" onClick={() => { setOpen(false); openChat(); }} className="mt-4 w-full rounded-full bg-[var(--ink)] py-4 text-sm text-[var(--cream)]">Prenota in chat</button>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
